import { compose } from 'redux';

import { formatTechDate } from 'modules/shared/utils';
import { WithQuerystringFiltering } from 'modules/shared/hocs';
import { WithFetchDatasByIdFromCMS, WithFetchDatasByIdFromCMSInputProps, WithCMSSEO } from 'modules/shared-cms/hocs';
import { DressThumbMetaProps } from '../../components';

import { QUERY } from './dresses-query';
import { DressesLoader } from './dresses-loader';
import { DressesProps } from './dresses-type';

const enhancer = compose<React.ComponentType<WithFetchDatasByIdFromCMSInputProps>>(
    WithFetchDatasByIdFromCMS<DressesProps>(QUERY, DressesLoader, undefined, [
        {
            name: 'dateFilter',
            filter: `data/startDate/iv le ${formatTechDate(new Date())} and data/endDate/iv ge ${formatTechDate(
                new Date(),
            )}`,
        },
    ]),
    WithCMSSEO(),
    WithQuerystringFiltering<keyof DressThumbMetaProps>(),
);
export default enhancer;
